module.exports = __webpack_public_path__ + "img/img13.d4127e00.svg";